import React from 'react'

import { StatusFilterDropdown } from '../filters/StatusFilterDropdown'
import { PaymentFilterDropdown } from '../filters/PaymentFilterDropdown'
import { SearchBox } from '../filters/SearchBox'
import { useModal } from '../state/ModalProvider'
import type { Deal } from '../types/deal'

interface Props {
  allDeals: Deal[]
}

export const PageSubheader: React.FunctionComponent<Props> = (props) => {
  const { allDeals } = props
  const { open } = useModal()

  function onNewDeal(): void {
    open({ kind: 'edit-deal', isNew: true })
  }

  return (
    <div className="page-subheader">
      <button type="button" className="btn-primary" onClick={onNewDeal}>
        New Deal
      </button>

      <div className="filter-bar" style={{ padding: 0, marginLeft: 'auto', flexWrap: 'nowrap' }}>
        <span className="filter-label">SHOW</span>
        <StatusFilterDropdown allDeals={allDeals} />
        <PaymentFilterDropdown allDeals={allDeals} />
      </div>

      <SearchBox />
    </div>
  )
}
